import { useMemo } from 'react';
import { useAuth } from './AuthContext';
import { bindOperationsAPI } from '../services/operationsScope';

export function useOperationsAPI<T extends object>(api: T): T {
  const { operationsScope } = useAuth();
  return useMemo(() => bindOperationsAPI(api, operationsScope), [api, operationsScope]);
}
